export default __webpack_public_path__ + "static/media/total-users.c1afe6c5.png";